import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { AppContext } from "../../context/AppContext";
import "../Backend/assets/css/editgamemodel.css";

const EditGame = ({ gameId, onClose, onUpdated }) => {
  const [formData, setFormData] = useState({
    name: "",
    game_title: "",
    category: "",
    enable: false,
    advertised: false,
    url: "",
    folder_path: "",
    thumbnail_img_path: "",
    description: "",
    meta_title: "",
    meta_keyword: "",
    meta_description: "",
    gameType: "",
    iso_link: "",
    playstore_link: "",
  });
  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploadImgMsg, setUploadImgMsg] = useState("");
  const [thumbnail, setThumbnail] = useState(null);
  const [getCategory, setGetCategory] = useState([]);
  const { baseUrl, token } = useContext(AppContext);

  const adminurl = "https://htmlgames4u.com/api";
  const fetchData = async () => {
    try {
      const res = await axios.get(`${baseUrl}/get-category`);
      if (res.data.success) {
        setGetCategory(res.data.data);
      } else {
        console.error("Failed to fetch categories:", res.data.message);
      }
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  };
  useEffect(() => {
    const editGame = async () => {
      if (!gameId) return;
      const res = await axios.get(`${adminurl}/games/${gameId}`);
      if (res) {
        setFormData(res.data);
      }
    };
    fetchData();
    editGame();
  }, [gameId]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const handleThumbUpload = async (e) => {
    if (!thumbnail) {
      return;
    }
    e.preventDefault();
    const formData = new FormData();
    formData.append("thumbnail", thumbnail);

    try {
      const res = await axios.post(`${baseUrl}/upload-thumbnail`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res) {
        //setSavegameEnabled(true)
        setUploadImgMsg("Thumbnail Img upload successfully");
      }
    } catch (err) {
      console.error(err);
    }
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setThumbnailFile(e.target.files[0]);
    setThumbnail(file);
    formData.thumbnail_img_path = `/thumbnail/${file.name}`;
    setPreview(URL.createObjectURL(file));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    for (const key in formData) {
      data.append(key, formData[key]);
    }
    if (thumbnailFile) {
      data.append("thumbnail", thumbnailFile);
    }

    try {
      const res = await axios.put(`${adminurl}/games/${gameId}`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      onUpdated();
      onClose();
    } catch (err) {
      console.error(err);
      alert("Error updating game.");
    }
  };

  return (
    <div className="model_main">
      <h3>Edit Game</h3>
      <form onSubmit={handleSubmit}>
        <div className="form_field">
          <label>Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Game Name"
          />
        </div>

        <div className="form_field">
          <label>Game Title</label>
          <input
            type="text"
            name="game_title"
            value={formData.game_title}
            onChange={handleChange}
            placeholder="Title"
          />
        </div>

        <div className="form_field">
          <label>Category</label>
          <select
            name="category"
            required
            className="form-control"
            onChange={handleChange}
            value={formData.category}
          >
            <option value="">Select Category</option>
            {getCategory.map((category, index) => (
              <option key={index} value={category.name}>
                {category.name}
              </option>
            ))}
          </select>
        </div>

        <div className="form_checkbox">
          <label>
            <input
              type="checkbox"
              name="enable"
              checked={formData.enable}
              onChange={handleChange}
            />{" "}
            Enabled
          </label>

          <label>
            <input
              type="checkbox"
              name="advertised"
              checked={formData.advertised}
              onChange={handleChange}
            />{" "}
            Advertised
          </label>
        </div>

        <div className="form_field">
          <label>URL</label>
          <input
            type="text"
            name="url"
            value={formData.url}
            onChange={handleChange}
            placeholder="URL"
          />
        </div>

        <div className="form_field">
          <label>Folder Path</label>
          <input
            type="text"
            name="folder_path"
            value={formData.folder_path}
            onChange={handleChange}
            placeholder="Folder Path"
          />
        </div>

        <div className="form_description">
          <div className="form_field">
            <label>Description</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Description"
            />
          </div>

          <div>
            <label>Thumbnail: </label>
            <input type="file" onChange={handleFileChange} />
          </div>
          {preview && (
            <img
              src={preview}
              alt="Thumbnail Preview"
              style={{ width: "100px", height: "100px", objectFit: "cover" }}
            />
          )}
          <small>Current: {formData.thumbnail_img_path}</small>

          <div>
            <button onClick={handleThumbUpload}>Upload</button>
            <p style={{ color: "green" }}>{uploadImgMsg}</p>
          </div>
        </div>

        <div style={{ display: "none" }} className="form_field">
          <label>Meta Tag: </label>
          <textarea
            name="metatag"
            value={formData.metatag || ""}
            onChange={handleChange}
            placeholder="Enter SEO meta tags..."
          />
        </div>

        <div className="form_field">
          <label>Meta Title: </label>
          <input
            type="text"
            name="meta_title"
            value={formData.meta_title}
            onChange={handleChange}
            placeholder="Title"
          />
        </div>

        <div className="form_field">
          <label>Meta Keyword</label>
          <input
            type="text"
            name="meta_keyword"
            value={formData.meta_keyword}
            onChange={handleChange}
            placeholder="keyword"
          />
        </div>

        <div className="form_field">
          <label>Meta Description</label>
          <textarea
            name="meta_description"
            value={formData.meta_description || ""}
            onChange={handleChange}
            placeholder="Enter SEO meta description..."
          />
        </div>

        <div className="form_field">
          <label>Game Type</label>
          <input
            type="text"
            name="gameType"
            value={formData.gameType}
            onChange={handleChange}
            placeholder="Game Type"
          />
        </div>

        <div className="form_field">
          <label>ISO Link</label>
          <input
            type="text"
            name="iso_link"
            value={formData.iso_link}
            onChange={handleChange}
            placeholder="ISO Link"
          />
        </div>

        <div className="form_field">
          <label>Playstore Link</label>
          <input
            type="text"
            name="playstore_link"
            value={formData.playstore_link}
            onChange={handleChange}
            placeholder="Playstore Link"
          />
        </div>

        <div className="form_btn">
          <button type="submit">Update Game</button>
          <button
            type="button"
            className="cancle"
            onClick={onClose}
            style={{ marginLeft: "10px" }}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditGame;
